export const DEFAULT_NOTIFICATION_TITLE = 'Live Stream';
export const MIN_SEARCH_LENGTH = 1;
export const NOTIFICATIONS_ENDPOINT = '/api/notifications/live-stream';



// WEBPACK FOOTER //
// ./src/show-index/constants/config.js